import flatpickr from "flatpickr";
import { useEffect, useRef, createElement } from "react";
import { Platform } from "react-native";

if (Platform.OS === 'web') {
  require("flatpickr/dist/themes/airbnb.css");
}

const TIME_PICKER = {
  enableTime: true,
  noCalendar: true,
  dateFormat: "h:i K"
};

const DATE_PICKER = {
  dateFormat: "d/m/y"
};

const DATE_TIME_PICKER = {
  enableTime: true,
  dateFormat: "d/m/y h:i K"
};

export default function WebPicker({
  mode = "date",
  style,
  value,
  onChange,
  isRange,
  minDate,
  maxDate,
  disabled
}) {
  const picker = useRef();

  useEffect(() => {
    const config =
      mode === "date"
        ? DATE_PICKER
        : mode === "time"
          ? TIME_PICKER
          : DATE_TIME_PICKER;
    config["minDate"] = minDate;
    config["maxDate"] = maxDate;

    flatpickr(picker.current, {
      ...config,
      defaultDate: value,
      mode: isRange ? "range" : "single",
      onChange: onChange,
      clickOpens: !disabled,
      inline: true,
    });
  }, []);

  useEffect(() => {
    if (value && picker.current._flatpickr) {
      if (minDate) picker.current._flatpickr.set("minDate", minDate);
      if (maxDate) picker.current._flatpickr.set("maxDate", maxDate);

      picker.current._flatpickr.setDate(value);
    }
  }, [value, maxDate, minDate]);

  useEffect(() => {
    if (minDate && picker.current._flatpickr) {
      picker.current._flatpickr.set("minDate", minDate);
    }
  }, [minDate]);

  useEffect(() => {
    if (maxDate && picker.current._flatpickr) {
      picker.current._flatpickr.set("maxDate", maxDate);
    }
  }, [maxDate]);

  return createElement("input", {
    ref: picker,
    style: inputStyle(style)
  });
}

const inputStyle = (style) => ({
  ...style,
  borderWidth: 1,
  padding: 10,
  color: "black",
  borderRadius: 8
});
